<template>
  <div>
    <input  class="form-control form-control-sm" v-bind:id="id" v-mask="'##.###.###/####-##'" v-model="value" />
  </div>
</template>
<script>
  import {mask} from 'vue-the-mask'
  export default {
    props: ['id', 'value'],
    directives: {mask}
  }
</script>


// WEBPACK FOOTER //
// src/components/utils/InputCnpj.vue